<template>
  <transition name="fade" appear>
    <div v-if="popupBalloon" :class="{'c-calendar-balloon':true,'c-calendar-balloon--leftpos': isLeft}">
       <div class="c-calendar-balloon__box">
        <div class="c-calendar-balloon__box__arrow"></div>
        <div class="c-calendar-balloon__box__inner">
          <div class="baloonHeader">
            <p class="baloonHeader__heading"><span class="baloonHeader__heading__halfsize _pu_year">{{year}}</span>年
              <span class="baloonHeader__heading__halfsize _pu_month">{{month}}</span>月
              <span class="baloonHeader__heading__halfsize _pu_date">{{day}}</span>日</p>
          </div>
          <div class="baloonBody">
            <ul class="baloonBody__listTask">
              <li>
                <!--<div class="c-calendar-task c-calendar-task--exam"><span class="label">中間テスト：国語，社会，数学</span></div>-->
              </li>
            </ul>
            <div class="graphBox">
              <div class="columnGraph">
                <div class="pieGraph">
                  <svg viewBox="0 0 172 172">
                    <circle v-for="(subj, i) in licensedSubject" :key="i"
                            :class="{'pie':true, ['pie--'+subj.value]:true}"
                            :ref="(el) => {circleRef[subj.value] = el}" cx="86" cy="86" r="76"/>
                  </svg>
                  <div class="pieGraph__data">
                    <div class="time"><span class="halfsize">{{ totalStudyTime }}</span>分</div>
                  </div>
                </div>
              </div>
              <div class="columnLegend">
                <ul class="listLegend">
                  <li v-for="(subj,i) in licensedSubject" :class="{'legend':true, ['legend--'+subj.value]:true}">
                    {{ subj.name }}<span class="hyphen">−</span><span class="halfsize _subject_num">{{ subjectStudyTime[i] }}</span>分
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
  import {ref, computed} from "vue";

  const totalStudyTime = ref(0)
  const subjectStudyTime = ref([])
  const circleRef = ref([])
  const props = withDefaults(
    defineProps<{
      isPopupBalloon?: boolean;
      isLeft?: boolean;
      year?: number;
      month?: number;
      day?: number;
      dataPieValue: Array<any>;
      licensedSubject: Array<any>;
    }>(),
    {
      isPopupBalloon: false,
      isLeft: false,
      year: new Date().getFullYear(),
      month: new Date().getMonth()+1,
      day: new Date().getDate(),
    }
  );

  const popupBalloon = computed(() => {
    if (props.isPopupBalloon) {
      const radius = 76;      // 半径
      const diameter = radius * 2; // 直径
      const perimeter = Math.PI * diameter; // 円周長

      // 総学習時間を取得
      subjectStudyTime.value = props.dataPieValue
      totalStudyTime.value = subjectStudyTime.value.reduce((a, b) => {
        return Number(a) + Number(b);
      });

      // 総学習時間から教科別に割り算して角度を取得
      let perimeter_per = [];
      let degrees = [];
      for (let i = 0; i < subjectStudyTime.value.length; i++) {
        let per = subjectStudyTime.value[i] / totalStudyTime.value;
        let degree = 360 * per;
        perimeter_per.push(perimeter * per);
        degrees.push(degree);
      }

      // 各教科circleでスタイル設定
      let timer;
      timer = setTimeout(() => {
        let increase_deg = 0;
        for (let i = 0; i < props.licensedSubject.length; i++) {
          let pie: HTMLElement = circleRef.value[props.licensedSubject[i].value]
          if (pie?.style) {
            pie.style.opacity = "1"
            pie.style.strokeDasharray = perimeter_per[i] + " " + perimeter
            pie.style.transform = "rotate(" + increase_deg + "deg)"
            increase_deg += degrees[i];
          }
        }
        clearTimeout(timer);
      }, 300);
    }
    return props.isPopupBalloon
  })
</script>
